import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = null;
type Props = {};
type HandlerType = Handler<Parameter, Props>;

export const ClearProductCategories: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductCategoriesState/ClearProductProperties",
    } as any);
};

export const chain = [ClearProductCategories];

const clearProductCategories = createHandlerChainRunner(chain, "ClearProductCategories");
export default clearProductCategories;
